// extracted by mini-css-extract-plugin
export default {"container":"i1-z","list":"j1-z"};